import React, { useMemo } from "react";

function SingleData({ infotipData }) {
  // Parse date in DD.MM.YYYY HH:mm:ss format
  //TAT logic
  function parseCustomDate(dateStr) {
    if (!dateStr) return null;
    const [day, month, yearAndTime] = dateStr.split('.');
    if (!yearAndTime) return null;
    const [year, time] = yearAndTime.trim().split(' ');
    return new Date(`${year}-${month}-${day}T${time || "00:00:00"}`);
  }

  const calculatedTAT = useMemo(() => {
    const createDate = parseCustomDate(infotipData.OrderDate);
    const history = infotipData.history || [];

    // Parse actions
    const parsedActions = history.map((entry) => {
      if (typeof entry !== "string") return null;
      const parts = entry.split("|");
      const obj = {};
      for (let i = 0; i < parts.length; i += 2) {
        obj[parts[i].trim()] = parts[i + 1]?.trim();
      }
      return {
        ActionCode: obj["Action"],
        ActionDate: parseCustomDate(obj["ChgDate"]),
      };
    }).filter(a => a && a.ActionCode && a.ActionDate);

    let tatDays = "N/A";

    if (!isNaN(createDate)) {
      const sortedActions = parsedActions.sort((a, b) => a.ActionDate - b.ActionDate);

      let effectiveStart = createDate;
      let effectiveEnd = null;
      let skipStart = null;
      let skipDays = 0;
      let orderClosed = false;

      for (let i = 0; i < sortedActions.length; i++) {
        const { ActionCode, ActionDate } = sortedActions[i];

        // If order closed
        if (["117", "176", "190", "191", "192", "193", "194", "195", "196", "197", "336", "340", "357", "361", "392", "282", "288"].includes(ActionCode)) {
          effectiveEnd = ActionDate;
          orderClosed = true;
          break;
        }

        // Pause only on 351
        if (ActionCode === "351") {
          if (!skipStart) {
            skipStart = new Date(ActionDate);
            effectiveEnd = ActionDate;
          }
          continue;
        }

        // Resume after pause
        if (skipStart) {
          const skipStartDate = new Date(skipStart.toDateString());
          const skipEndDate = new Date(ActionDate.toDateString());
          const diff = Math.max(
            0,
            Math.floor((skipEndDate - skipStartDate) / (1000 * 60 * 60 * 24))
          );
          skipDays += diff;
          skipStart = null;
        }

        effectiveEnd = ActionDate;
      }

      // If paused but no resume → skip until today
      if (skipStart) {
        const skipStartDate = new Date(skipStart.toDateString());
        const skipEndDate = new Date(new Date().toDateString());
        const diff = Math.max(
          0,
          Math.floor((skipEndDate - skipStartDate) / (1000 * 60 * 60 * 24))
        );
        skipDays += diff;
        skipStart = null;
      }

      // If no close → count till today
      if (!orderClosed) {
        effectiveEnd = new Date();
      } else if (!effectiveEnd) {
        effectiveEnd = sortedActions.length > 0
          ? sortedActions[sortedActions.length - 1].ActionDate
          : new Date();
      }

      // ✅ Final TAT (ignoring time, only days)
      const start = new Date(effectiveStart.toDateString());
      const end = new Date(effectiveEnd.toDateString());
      const totalDays = Math.max(
        0,
        Math.floor((end - start) / (1000 * 60 * 60 * 24))
      );
      tatDays = Math.max(0, totalDays - skipDays);
    }

    return tatDays;
  }, [infotipData]);
  return (
    // <div className="wo-infotip">
    //   <table style={{fontSize: "15px", border: "solid 2px rgb(172, 172, 255)", padding: "1%", margin: "0"}}>
    //     <thead style={{fontSize: "small"}}>
    //       <tr className="table-header-row">
    //         <th>Seq#</th>
    //         <th>Order Date & Time</th>
    //         {infotipData.Infotip_WO_Number && <th>Infotip WO number</th>}
    //         <th>WP WO Number</th>
    //         <th>Handling Type</th>
    //         <th>Product Name</th>
    //         <th>Serial Number</th>
    //         <th>Country</th>
    //         <th>Workshop</th>
    //         <th>ASP</th>
    //         <th>Infotip Status Woodpecker</th>
    //         <th>Creator Role</th>
    //         <th>Type of Order</th>
    //         <th>RR</th>
    //       </tr>
    //       <tr>
    //         <td colSpan="14">
    //           <hr />
    //         </td>
    //       </tr>
    //     </thead>
    //     <tbody>
    //           <tr className="table-body-row" key={infotipData._id}>
    //             <td>1</td>
    //             <td>{infotipData.Order_Date_Time}</td>
    //             {infotipData.Infotip_WO_Number && <td>{infotipData.Infotip_WO_Number}</td>}
    //             <td className="uline">{infotipData.WP_WO_Number}</td>
    //             {/* <td>{(infotipData.Handling_Type).split(':')[0]}</td> */}
    //             <td>{typeof infotipData.Handling_Type === 'string' ? infotipData.Handling_Type.split(':')[0] : infotipData.Handling_Type}</td>
    //             <td>{infotipData.Product_Name}</td>
    //             <td>{infotipData.Serial_Number}</td>
    //             {/* <td>{(infotipData.Country).split(' ')[0]}</td> */}
    //             <td>{typeof infotipData.Country === 'string' ? infotipData.Country.split(' ')[0] : infotipData.Country}</td>
    //             <td>{infotipData.Workshop}</td>
    //             <td>{infotipData.ASP}</td>
    //             {/* <td className={(infotipData.Infotip_Status).split(':')[0] === "96" ? "green-status" : "red-status"}>{infotipData.Infotip_Status}</td> */}
    //             <td className={typeof infotipData.Infotip_Status === 'string' ? (infotipData.Infotip_Status.split(':')[0] === "96" ? "green-status" : "red-status"): infotipData.Infotip_Status}>{infotipData.Infotip_Status}</td>                
    //             <td>{infotipData.Creator_Role}</td>
    //             <td>{infotipData.Type_of_Order}</td>
    //             <td>{infotipData.repeat_repair}</td>
    //           </tr>
    //     </tbody>
    //   </table>
    // </div>


    <div className="wo-infotip">
      {infotipData && <table style={{ fontSize: "15px", border: "solid 2px rgb(172, 172, 255)", padding: "1%", margin: "0" }}>
        <thead style={{ fontSize: "small" }}>
          <tr className="table-header-row">
            <th>Seq#</th>
            <th>Order Date & Time</th>
            {infotipData.OrderName && <th>Infotip WO number</th>}
            {infotipData.WP_WO_Number && <th>WP WO Number</th>}
            <th>Handling Type</th>
            <th>Product Name</th>
            <th>Serial Number</th>
            <th>Country</th>
            <th>Workshop</th>
            <th>ASP</th>
            <th>Infotip Status Woodpecker</th>
            {/* <th>Creator Role</th> */}
            <th>Assignee</th>
            <th>Type of Order</th>
            <th>RR</th>
            <th>TAT</th>
          </tr>
          <tr>
            <td colSpan="14">
              <hr />
            </td>
          </tr>
        </thead>
        <tbody>
          <tr className="table-body-row" key={infotipData.OrderName}>
            <td>1</td>
            <td>{infotipData.OrderDate}</td>
            {infotipData.OrderName && <td>{infotipData.OrderName}</td>}
            {infotipData.WP_WO_Number && <td className="uline">{infotipData.WP_WO_Number}</td>}
            {/* <td>{typeof infotipData.Handling_Type === 'string' ? infotipData.HandlingType.split(':')[0] : infotipData.HandlingType}</td> */}
            <td>{infotipData.HandlingType}</td>
            <td>{infotipData.ProductName}</td>
            <td>{infotipData.SerialNumber}</td>
            {/* <td>{typeof infotipData.Country === 'string' ? infotipData.Country.split(' ')[0] : infotipData.CountryId}</td> */}
            <td>{infotipData.CountryId}</td>
            <td>{infotipData.WorkshopName}</td>
            {/* <td>{infotipData.ASP}</td> */}
            <td>xxxx</td>
            {/* <td className={typeof infotipData.Infotip_Status === 'string' ? (infotipData.Infotip_Status.split(':')[0] === "96" ? "green-status" : "red-status") : infotipData.Infotip_Status}>{infotipData.Infotip_Status}</td> */}
            <td className={infotipData.OrderState === "96" ? "green-status" : "red-status"}>{infotipData.OrderState}</td>
            {/* <td>{infotipData.CreatorRole}</td> */}
            <td>xxxx</td>
            <td>{infotipData.TypeOfOrder}</td>
            {/* <td>{infotipData.repeat_repair}</td> */}
            <td>xxxx</td>
            <td>{calculatedTAT}</td>
          </tr>
        </tbody>
      </table>}
    </div>
  );
}

export default SingleData;
